import {DashboardWidgetOption, DashboardWidgetSize, DashboardWidgetType} from './dashboards.types';

const MAX_DIMENSIONS = 3;
const MAX_METRICS = 10;
const NUMBER_OF_COLUMNS = 6;

const DEFAULT_WIDGET_TYPE: Partial<Record<DashboardWidgetType, DashboardWidgetOption>> = {
  [DashboardWidgetType.NONE]: {
    maxDimensions: 0,
    maxMetrics: 0,
    sizes: [
      DashboardWidgetSize.WIDTH_1_HEIGHT_1,
      DashboardWidgetSize.WIDTH_1_HEIGHT_2,
      DashboardWidgetSize.WIDTH_2_HEIGHT_2,
      DashboardWidgetSize.WIDTH_2_HEIGHT_4,
      DashboardWidgetSize.WIDTH_3_HEIGHT_2,
      DashboardWidgetSize.WIDTH_3_HEIGHT_4,
      DashboardWidgetSize.WIDTH_6_HEIGHT_2,
      DashboardWidgetSize.WIDTH_6_HEIGHT_4,
    ],
  },
};

const WIDGET_ORIGIN_SIZE: Record<DashboardWidgetSize, {width: number; height: number}> = {
  [DashboardWidgetSize.NONE]: {
    width: 0,
    height: 0,
  },
  [DashboardWidgetSize.WIDTH_1_HEIGHT_1]: {
    width: 1,
    height: 1,
  },
  [DashboardWidgetSize.WIDTH_1_HEIGHT_2]: {
    width: 1,
    height: 2,
  },
  [DashboardWidgetSize.WIDTH_2_HEIGHT_2]: {
    width: 2,
    height: 2,
  },
  [DashboardWidgetSize.WIDTH_2_HEIGHT_4]: {
    width: 2,
    height: 4,
  },
  [DashboardWidgetSize.WIDTH_3_HEIGHT_2]: {
    width: 3,
    height: 2,
  },
  [DashboardWidgetSize.WIDTH_3_HEIGHT_4]: {
    width: 3,
    height: 4,
  },
  [DashboardWidgetSize.WIDTH_6_HEIGHT_2]: {
    width: 6,
    height: 2,
  },
  [DashboardWidgetSize.WIDTH_6_HEIGHT_4]: {
    width: 6,
    height: 4,
  },
};

const defaultWidgetSizes: Record<DashboardWidgetType, {width: number; height: number}> = {
  [DashboardWidgetType.MULTI_TABLE]: {
    width: 6,
    height: 4,
  },
  [DashboardWidgetType.TABLE]: {
    width: 6,
    height: 4,
  },
  [DashboardWidgetType.PIE]: {
    width: 2,
    height: 2,
  },
  [DashboardWidgetType.MAP]: {
    width: 6,
    height: 4,
  },
  [DashboardWidgetType.LINE_AREA_CHART]: {
    width: 2,
    height: 2,
  },
  [DashboardWidgetType.HORIZONTAL_BAR]: {
    width: 2,
    height: 2,
  },
  [DashboardWidgetType.BAR]: {
    width: 2,
    height: 2,
  },
  [DashboardWidgetType.CARD]: {
    width: 1,
    height: 1,
  },
  [DashboardWidgetType.NONE]: {
    width: 0,
    height: 0,
  },
};

export {
  DEFAULT_WIDGET_TYPE,
  defaultWidgetSizes,
  MAX_DIMENSIONS,
  MAX_METRICS,
  NUMBER_OF_COLUMNS,
  WIDGET_ORIGIN_SIZE,
};
